import {
	useAllergens,
	useBaseIngredientList,
	useCo2Labels,
	useIngredientCategories,
	useIngredientRanges,
	useNutriScoreLabels,
	useSeasons,
	useTagList,
} from 'context/Store';

export default function useIngredientSearchData() {
	const baseIngredientList = useBaseIngredientList();
	const co2Labels = useCo2Labels();
	const ingredientCategories = useIngredientCategories();
	const ranges = useIngredientRanges();
	const seasons = useSeasons();
	const tags = useTagList();
	const allergens = useAllergens();
	const nutriScoreLabels = useNutriScoreLabels();

	return {
		allergens,
		baseIngredientList,
		co2Labels,
		ingredientCategories,
		nutriScoreLabels,
		ranges,
		seasons,
		tags,
	};
}
